// extracted by mini-css-extract-plugin
module.exports = {"eula":"_2c62aac","item":"_147be7e","rootBody":"_a2083c0","gridBlock":"_9660c6b","block":"_53d8a71","number":"_a7a742d","terms":"_e310a0e","title":"_f309e78"};